import { RoleGuard } from '../guards';
import VentureProfile from '../../pages/ventures/profile';
import VentureHelpCenter from '../../pages/ventures/helpcenter';
import VentureAddressBook from '../../pages/ventures/addressbook';
import VentureWorkingInProgress from '../../pages/ventures/wip';
import DbaasSubscriptions from '../../pages/ventures/dbaas/containers/subscriptions';
import { PurchasePrograms } from '../../pages/ventures/subscription';
import SubscriptionDetail from '../../pages/ventures/subscription/subscription-detail';
import Business from '../../pages/ventures/platform-management/businesses/containers/businesses';
import BusinessUsers from '../../pages/ventures/platform-management/business-users/containers/business-users';
import ManagementSubscriptions from '../../pages/ventures/platform-management/np-subscriptions/containers/subscriptions';
import Forums from '../../pages/ventures/forums/containers/forums';
import MyCommunities from '../../pages/ventures/community/mycommunities/containers/mycommunities';
import MyEvents from '../../pages/ventures/events/myevents/containers/myevents';
import MyPrograms from '../../pages/ventures/programs/myprograms/containers/myprograms';
import MyCommunity from '../../pages/ventures/community/mycommunities/containers/mycommunity';
import { AvailableCommunities } from '../../pages/ventures/community/availablecommunities/containers/availablecommunities';
import Myevent from '../../pages/ventures/events/myevents/containers/myevent';
import Myprogram from '../../pages/ventures/programs/myprograms/containers/myprogram';
import { AvailableEvents } from '../../pages/ventures/events/availableevents/containers/availableevents';
import { AvailablePrograms } from '../../pages/ventures/programs/availableprograms/containers/availableprograms';
import VentureIe from '../../pages/ventures/mysubscriptions/ie/venture-ie';
import VentureNp from '../../pages/ventures/mysubscriptions/np/venture-np';
import VentureDbaas from '../../pages/ventures/mysubscriptions/dbaas/venture-dbaas';
import VentureDbnbiz from '../../pages/ventures/mysubscriptions/dbnbiz/venture-dbnbiz';
import VentureDbnPartner from '../../pages/ventures/mysubscriptions/dbnpartner/venture-dbn-partner';
import VentureDbnAgent from '../../pages/ventures/mysubscriptions/dbnagent/venture-dbn-agent';
import VentureCalendar from '../../pages/ventures/calendar/calendar';
import VentureInboxes from '../../pages/ventures/inbox/containers/inboxes';
import VentureInbox from '../../pages/ventures/inbox/containers/inbox';


export const VentureRoutes = () => {

	return ([

		// Start - Profile 
		{ path: 'forums', element: <RoleGuard roles={["Trainer"]}><Forums /></RoleGuard> },
		{ path: 'platform-management/businesses', element: <RoleGuard roles={["Trainer"]}><Business /></RoleGuard> },
		{ path: 'platform-management/business-users', element: <RoleGuard roles={["Trainer"]}><BusinessUsers /></RoleGuard> },
		{ path: 'platform-management/np-subscriptions', element: <RoleGuard roles={["Trainer"]}><ManagementSubscriptions /></RoleGuard> },
		{ path: 'dbaas/subscriptions', element: <RoleGuard roles={["Trainer"]}><DbaasSubscriptions /></RoleGuard> },
		{ path: 'profile', element: <RoleGuard roles={["Trainer"]}><VentureProfile /></RoleGuard> },
		{ path: 'helpcenter', element: <RoleGuard roles={["Trainer"]}><VentureHelpCenter /></RoleGuard> },
		{ path: 'address', element: <RoleGuard roles={["Trainer"]}><VentureAddressBook /></RoleGuard> },
		{ path: 'wip', element: <RoleGuard roles={["Trainer"]}><VentureWorkingInProgress /></RoleGuard> },
		{ path: 'purchase-programs/:id', element: <RoleGuard roles={["Trainer"]}><SubscriptionDetail /></RoleGuard> },
		{ path: 'purchase-programs', element: <RoleGuard roles={["Trainer"]}><PurchasePrograms /></RoleGuard> },
		{ path: 'community/availablecommunities', element: <RoleGuard roles={["Trainer"]}><AvailableCommunities /></RoleGuard> },
		{ path: 'community/mycommunities', element: <RoleGuard roles={["Trainer"]}><MyCommunities /></RoleGuard> },
		{ path: 'community/mycommunities/:id', element: <RoleGuard roles={["Trainer"]}><MyCommunity /></RoleGuard> },
		{ path: 'events/availableevents', element: <RoleGuard roles={["Trainer"]}><AvailableEvents /></RoleGuard> },
		{ path: 'events/myevents', element: <RoleGuard roles={["Trainer"]}><MyEvents /></RoleGuard> },
		{ path: 'events/myevents/:id', element: <RoleGuard roles={["Trainer"]}><Myevent /></RoleGuard> },
		{ path: 'programs/myprograms/:id', element: <RoleGuard roles={["Trainer"]}><Myprogram /></RoleGuard> },
		{ path: 'programs/myprograms', element: <RoleGuard roles={["Trainer"]}><MyPrograms /></RoleGuard> },
		{ path: 'programs/availableprograms', element: <RoleGuard roles={["Trainer"]}><AvailablePrograms /></RoleGuard> },
		{ path: 'mysubscriptions/ie', element: <RoleGuard roles={["Trainer"]}><VentureIe /></RoleGuard> },
		{ path: 'mysubscriptions/np', element: <RoleGuard roles={["Trainer"]}><VentureNp /></RoleGuard> },
		{ path: 'mysubscriptions/dbaas', element: <RoleGuard roles={["Trainer"]}><VentureDbaas /></RoleGuard> },
		{ path: 'mysubscriptions/dbnbiz', element: <RoleGuard roles={["Trainer"]}><VentureDbnbiz /></RoleGuard> },
		{ path: 'mysubscriptions/dbnagent', element: <RoleGuard roles={["Trainer"]}><VentureDbnAgent /></RoleGuard> },
		{ path: 'mysubscriptions/dbnpartner', element: <RoleGuard roles={["Trainer"]}><VentureDbnPartner /></RoleGuard> },
		{ path: 'calendar', element: <RoleGuard roles={["Trainer"]}><VentureCalendar /></RoleGuard> },
		{ path: 'inbox', element: <RoleGuard roles={["Trainer"]}><VentureInboxes /></RoleGuard> },
		{ path: 'inbox/:id', element: <RoleGuard roles={["Trainer"]}><VentureInbox /></RoleGuard> },
	

		
		// End - Profile


	])
};
